
export default {
  setId: (state, id) => {
    state.id = id
  },
  setPageCharge: (state, pageCharge) => {
    state.pageCharge = pageCharge
  },
}
